import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card card--default" }
const _hoisted_2 = { class: "card__root" }
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 0,
  class: "card__figure"
}
const _hoisted_5 = ["src", "srcset"]
const _hoisted_6 = { class: "card__footer" }
const _hoisted_7 = { class: "card__title" }
const _hoisted_8 = { class: "card__description" }
const _hoisted_9 = { class: "card__cta" }
const _hoisted_10 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_close_icon = _resolveComponent("close-icon")!
  const _component_arrow_right = _resolveComponent("arrow-right")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(["card__icon-close", {'card__icon-close--black' : !this.digitalSolution.image}]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
    }, [
      _createVNode(_component_close_icon)
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", { href: _ctx.link }, [
        (this.digitalSolution.image)
          ? (_openBlock(), _createElementBlock("figure", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.img_1x.link,
                alt: "",
                class: "card__image",
                srcset: `${_ctx.img_4x.link} 1920w, ${_ctx.img_3x.link} 1440w, ${_ctx.img_2x.link} 960w, ${_ctx.img_1x.link}, 480w`,
                sizes: "(min-width: 1440px) 1920px, (min-width: 960px) 1440px, (min-width: 480px) 960px, 480px"
              }, null, 8, _hoisted_5)
            ]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_3),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.digitalSolution.title), 1),
        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.digitalSolution.metaDescription), 1),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("a", {
            href: _ctx.link,
            class: "btn"
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('servicePhases.readMore.buttonLabel')), 1),
            _createVNode(_component_arrow_right)
          ], 8, _hoisted_10)
        ])
      ])
    ])
  ]))
}